import colors from "../colors.js";

export default colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Tableau10.js
// module id = 611
// module chunks = 0